'use client'

import { ReactNode, useState } from 'react'
import { IS_PRODUCTION_DEPLOYMENT } from '@/config/environments.config'
import CartDebug from './CartDebug'
import CustomerInfoDebug from './CustomerInfoDebug'
import StoreDebug from './StoreDebug'
import styles from './DebugTray.module.css'
import Actions from '@/app/_components/DebugComponents/Actions'

const DebugTrayInner = (): ReactNode => {
  const [open, setOpen] = useState(false)

  return (
    <div className={styles.tray} data-open={open || undefined}>
      <button
        type="button"
        className={styles.tab}
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        aria-controls="debug-tray-content"
      >
        <span className={styles.tabIcon} aria-hidden="true">
          {open ? '\u2715' : '\u2699'}
        </span>
        <span className={styles.tabLabel}>Debug</span>
      </button>

      {open && (
        <div id="debug-tray-content" className={styles.content}>
          <StoreDebug />
          <CartDebug />
          <CustomerInfoDebug />
          <Actions />
        </div>
      )}
    </div>
  )
}

const DebugTray = (): ReactNode => (IS_PRODUCTION_DEPLOYMENT ? null : <DebugTrayInner />)

export default DebugTray
